import { apiRequest } from "../core.js";

export function saveTempImage(image) {
  const url = process.env.REACT_APP_BACKEND_HOST + `/api/image/temp`;

  let formData = new FormData();
  formData.append('image', image);

  let options = {
    method: "POST",
    credentials: "same-origin",

    body: formData
  };

  return apiRequest(url, options);
}

export function getFullImageUrl(name) {
  return process.env.REACT_APP_FILE_SERVICE_URL + `/api/avatars/${name}`;
}

export function getFullGalleryImageUrl(name) {
    return process.env.REACT_APP_FILE_SERVICE_URL + `/api/gallery/${name}`;
}

export function getInstagramPhoto() {
  const url =  process.env.REACT_APP_BACKEND_HOST + `/api/image/instagram`;

  return apiRequest(url);
}
